import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import { Menu } from 'primereact/menu';
import { Column } from 'primereact/column';
import { FileUpload } from 'primereact/fileupload';
import { GenericComponent } from '../../components/GenericComponent';
import { InputComponent } from '../../components/InputComponent';
import { InstitucionPep } from '../../models/InstitucionPep';
import { InstitucionService } from '../../service/InstitucionService';
import AdjuntoService from '../../service/AdjuntoService';
import { useLazyParams } from '../../hooks/useLazyParams';
import { TablaDinamica } from '../../components/TablaDinamica';

export const Institucion = () => {
    let fileRef = useRef(null);
    const toast = useRef(null);
    const menuRef = useRef(null);
    const generic = new GenericComponent();
    const omodel = new InstitucionPep();
    const institucionSrv = new InstitucionService();
    const adjuntoService = new AdjuntoService();
    const [permss, setPermss] = useState(null);
    const [dialogSubir, setDialogSubir] = useState(false);
    const [dialogInstitucion, setDialogInstitucion] = useState(false);
    const [archivo, setArchivo] = useState(null);
    const [institucionFila, setInstitucionFila] = useState(null); // Guarda la fila seleccionada para el menú
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { inText, inDrop } = InputComponent({ omodel, errors, control, permss, id: getValues('id') });
    const tablaEstado = useLazyParams({ modelo: omodel.model });

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tablaEstado.lazyParams]);

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;

        if (permss == null) {
            _lazyParams.rtipo = true;
        }

        institucionSrv.getInstitucion({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
            }
        }).catch(err => {
            generic.funcError(err, toast);
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        // Por defecto al crear, el estado será "Activo"
        reset({ ...defaultValues, estado: omodel.estadosOpciones[1] });
        setDialogInstitucion(true);
    }

    const onSubmit = (data) => {
        if (getValues('id') == null) {
            institucionSrv.newInstitucion(data).then(res => {
                generic.funcSuccess(res, toast);
                setDialogInstitucion(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        } else {
            institucionSrv.editarInstitucion(data).then(res => {
                generic.funcSuccess(res, toast);
                setDialogInstitucion(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const editarInstitucion = () => {
        institucionSrv.consultarInstitucion(institucionFila.id).then(res => {
            let _inst = res.data;
            // Mapeamos el estado numérico al objeto del dropdown en el modelo
            if (_inst.estado != null) {
                _inst.estado = omodel.estadosOpciones.find(e => e.cat_id === _inst.estado) || omodel.estadosOpciones[0];
            }

            reset(generic.renewValues(_inst, omodel.model));
            setDialogInstitucion(true);
        });
    }

    const subirArchivo = () => {
        setArchivo(null);
        setDialogSubir(true);
    }

    const confirmDelete = () => {
        confirmDialog({
            message: `¿Está seguro de eliminar la institución ${institucionFila.razon_social}?`,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                institucionSrv.eliminarInstitucion(institucionFila.id).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => {
                    generic.funcDeleteError(error, toast);
                });
            }
        });
    }

    const itemsMenu = () => {
        const items = [];
        items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editarInstitucion() });
        // items.push({ label: 'Subir Archivo', icon: 'pi pi-cloud-upload', command: () => subirArchivo() });
        items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete() });

        return [{ label: 'Opciones', items: items }];
    }

    const accionesTemplate = (rowData) => {
        return (
            <div className="flex justify-content-center">
                <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
                    onClick={(e) => { setInstitucionFila(rowData); menuRef.current.toggle(e); }} />
            </div>
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} exportable={false} style={{ minWidth: '8rem', textAlign: 'center' }} />
    );

    const selectFile = (e) => {
        const size = parseInt(process.env.REACT_APP_PEP_SIZE || 2050000);
        if (e.files[0].size > size) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Tamaño máximo excedido', life: 3000 });
        } else {
            setArchivo(e.files[0]);
        }
        fileRef?.clear();
    }

    const subida = () => {
        if (archivo == null) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el archivo.', life: 3000 });
            return;
        }
        const formData = new FormData();
        formData.append('file', archivo);
        formData.append('tipo', 'institucion');
        formData.append('id', institucionFila?.id);
        const unuevo = 'administracion/institucion/individual';
        adjuntoService.newAdjunto(formData, unuevo).then(res => {
            setDialogSubir(false);
            setArchivo(null);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    }

    const isEdit = getValues('id') != null;

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nueva institución', permss)}
                    end={generic.rightToolbarTemplate(tablaEstado.data, omodel, 'Listado_instituciones', 'LISTADO INSTITUCIONES')}>
                </Toolbar>
                <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
            </Card>

            <Dialog visible={dialogSubir} header={`Subir archivo - ${institucionFila?.ruc}`} modal className="p-fluid modal-ssize" onHide={() => setDialogSubir(false)} style={{ width: '500px' }}>
                <div className="formgrid grid mb-4">
                    <div className="field col-12">
                        <label className="font-bold">Seleccione un anexo PDF*</label><br />
                        <FileUpload name="file" accept=".pdf" maxFileSize={2050000} mode="basic"
                            customUpload chooseLabel="Seleccione" onSelect={selectFile} ref={ref => { fileRef = ref }} />
                        <div className="mt-2 text-primary font-semibold">{archivo?.name}</div>
                    </div>
                </div>
                <div className="flex justify-content-end gap-2">
                    <Button label="Cerrar" icon="pi pi-times" outlined className="p-button-secondary" onClick={() => setDialogSubir(false)} />
                    <Button label="Subir Documento" icon="pi pi-cloud-upload" className="p-button-primary" onClick={() => subida()} />
                </div>
            </Dialog>

            <Dialog visible={dialogInstitucion} header={!isEdit ? "Nueva Institución" : "Editar Institución"} modal className="p-fluid" onHide={() => setDialogInstitucion(false)} style={{ maxWidth: '800px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inText('razon_social', { icon: 'pi pi-building' }, 6)}
                        {inText('ruc', { ...generic.infoIdentificacion('ruc'), icon: 'pi pi-hashtag' }, 6)}
                        {inText('observacion', { icon: 'pi pi-comment' }, 12)}
                        {isEdit && (
                            <>
                                <div className="col-12 mt-3 mb-2"><h6 className="text-secondary border-bottom-1 pb-2">Datos de Consulta (Web)</h6></div>
                                {inText('url_directorio', { icon: 'pi pi-globe' }, 12)}
                                {inText('url_remuneracion', { icon: 'pi pi-dollar' }, 12)}
                                {inText('periodo_datos', { icon: 'pi pi-calendar' }, 6)}
                            </>
                        )}
                        <div className="col-12 mt-3 mb-2"><h6 className="text-secondary border-bottom-1 pb-2">Configuración</h6></div>
                        {inDrop('estado', omodel.estadosOpciones, { lab: omodel.optionLabel }, 6)}
                    </div>
                    <div className="flex justify-content-end gap-2 mt-4">
                        <Button label="Cancelar" icon="pi pi-times" type="button" severity="secondary" outlined onClick={() => setDialogInstitucion(false)} />
                        <Button label="Guardar" icon="pi pi-save" type="submit" severity="warning" />
                    </div>
                </form>
            </Dialog>
        </>
    )
}
